/** A table booking (any party size, a large group included) rather than venue hire or the pool table. */
export function isTableFlow(store: { selection: { mode?: string } | null; largeBookingType: string | null }): boolean {
  return store.selection?.mode === 'table' && store.largeBookingType !== 'function_event'
}
